<!--
 * @version: V1.0.0
 * @Date: 2023-11-02 16:26:31
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-14 17:06:49
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\restockin\index.vue
 * @Descripttion:
-->
<template>
  <div v-loading.fullscreen='loading'>
    <el-card>
      <div class="statistic">
        <div style="margin-right: 264px;">已设置可用状态: {{ statistic.usable ? statistic.usable : 0 }}</div>
        <div>已设置报废状态: {{ statistic.invalid ? statistic.invalid : 0 }}</div>
      </div>
      <condition-search ref="search" :query-items="queryItems" :search-param="searchParam" @search="search"
        @reset="reset"></condition-search>
      <el-table :data="pageListData" height="calc(100vh - 440px)" style="overflow: auto;margin-top: 12px">
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column width="160px" prop="packLevel" label="包装层级"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="completeUdi" label="UDI码"> </el-table-column>
        <el-table-column width="160px" prop="type" label="操作类型">
          <template slot-scope="{ row }">
            <dict-tag :options="dictObj.reback_status" :value="row.type" />
          </template>
        </el-table-column>
        <el-table-column width="160px" prop="operateUserName" label="操作人"> </el-table-column>
        <el-table-column width="160px" prop="" label="操作时间">
          <template slot-scope="{ row }">
            {{ row.operateTime ? parseTime(row.operateTime) : null }}
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page-sizes="[10, 20, 50, 100]"
        :page.sync="searchParam.pageNum" :limit.sync="searchParam.pageSize" @pagination="getPageListData" />

    </el-card>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { getRestockinStatistic, getRestockinList } from '@/api/restocking'

export default {
  props: {},
  data() {
    return {
      pageListData: [],
      statistic: {},
      loading: false,
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          type: 'input',
          placeholder:'UDI码/包装层级'
        },
        {
          label: '操作类型',
          field: 'type',
          type: 'select',
          dictType: 'reback_status',
          options: []
        },
        {
          label: '操作时间',
          field: 'operateTime',
          type: 'date',
        },
      ],
      dictObj: {
        reback_status: []
      },
      searchParam: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.getPageListData()
    this.getDicts(['reback_status'])
  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          const findIndex = this.queryItems.findIndex(item => item.dictType === dictType)
          this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
        })
      })
    },
    // 查询
    search() {
      this.searchParam.pageNum = 1;
      this.getPageListData()
    },
    // 重置
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },
    // 获取重入库记录
    getPageListData() {
      this.loading = true;

      const params = JSON.parse(JSON.stringify(this.searchParam))
      if (params.operateTime) {
        const [startDate, endDate] = params.operateTime
        params.startDate = startDate
        params.endDate = endDate
        delete params.operateTime
      }
      getRestockinList(params)
        .then((res) => {
          this.pageListData = res.rows;
          this.searchParam.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
      this.getStatistic();
    },
    getStatistic() {
      getRestockinStatistic()
        .then((res) => {
          this.statistic = res.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.statistic {
  display: flex;
  font-size: 20px;
  color: #333333;
  background-color: #F2F2F2;
  padding: 20px;
  margin-bottom: 24px;
}
</style>
